import { SHOW, HIDE } from '../../consts';
import { FORM, MODAL } from './actionTypes';

export function showAuthForm (formType = 'signin') {
  return {
    type: FORM + SHOW,
    formType: formType
  };
}

export function hideAuthForm () {
  return {
    type: FORM + HIDE
  };
}

export function showAuthModal (message) {
  return {
    type: MODAL + SHOW,
    message: message
  };
}

export function hideAuthModal () {
  return {
    type: MODAL + HIDE
  };
}



// WEBPACK FOOTER //
// ./src/app/Auth/actions.js